import type { PlanStatus } from './PlanStatus';

type GetPlanActionsParams = {
  planStatus: PlanStatus;
  isChargeable: boolean;
  isInTrial?: boolean;
  isStarterPlan?: boolean;
};

type PlanActions = {
  showReactivate: boolean;
  showActivateStarterNow: boolean;
  showKeepAccess: boolean;
  showUpgrade: boolean;
  showCancel: boolean;
};

export function getPlanActions({
  planStatus,
  isChargeable,
  isInTrial = false,
  isStarterPlan = false,
}: GetPlanActionsParams): PlanActions {
  // A Starter-plan trial user on an active (non-cancelled, non-cancellation-scheduled) subscription
  // can activate paid Starter immediately regardless of whether a payment method is already on file —
  // the payment check lives on the modal's confirm button (PRE-2726). This is the reachable entry
  // point that "Keep access" is not (it hides once chargeable). Restricting to 'active' keeps the
  // "Keep access" (undo-cancellation) affordance for a trial user with a scheduled cancellation.
  const showActivateStarterNow = planStatus === 'active' && isInTrial && isStarterPlan;

  return {
    showReactivate: planStatus === 'cancelled',
    showActivateStarterNow,
    showKeepAccess:
      planStatus !== 'cancelled' &&
      (!isChargeable || planStatus === 'cancellation_scheduled') &&
      !showActivateStarterNow,
    showUpgrade: planStatus !== 'cancelled',
    showCancel: planStatus === 'active',
  };
}
